
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card, CardContent } from "@/components/ui/card";

const seoLinks = [
  {
    title: "Digital Billboard & Signage Booking",
    links: [
      { label: "Digital Signage Booking Platform", href: "/digital-signage-booking" },
      { label: "Online Digital Hoarding Reservation", href: "/digital-hoarding" },
      { label: "LED Advertising Board Booking", href: "/led-billboard-booking-online" },
      { label: "Billboard Booking Online", href: "/billboard-booking-online" },
      { label: "Advertise on Billboards", href: "/advertise-on-billboards" },
    ],
  },
  {
    title: "Book by Location",
    links: [
      { label: "Book Digital Billboard in Delhi", href: "/book-digital-billboard-in-delhi" },
      { label: "Rent Billboard Space in NCR", href: "/rent-billboard-space-ncr" },
      { label: "Digital Hoarding Rates in Gurgaon", href: "/digital-hoarding-rates-in-gurgaon" },
      { label: "Best Locations for Billboards in Noida", href: "/best-locations-for-billboards-in-noida" },
      { label: "High-Traffic Billboard Locations in Delhi", href: "/high-traffic-billboard-locations-in-delhi" },
      { label: "Digital Signage Advertising Delhi Metro", href: "/digital-signage-advertising-delhi-metro" },
    ],
  },
  {
    title: "Planning & Costs",
    links: [
      { label: "Outdoor Advertising Costs Delhi", href: "/outdoor-advertising-costs-delhi" },
      { label: "Billboard Advertising Rates in India", href: "/billboard-advertising-rates-in-india" },
      { label: "Compare Billboard Prices Delhi", href: "/compare-billboard-prices-delhi" },
      { label: "Affordable Outdoor Advertising Delhi NCR", href: "/affordable-outdoor-advertising-delhi-ncr" },
      { label: "Billboard Advertising ROI Delhi", href: "/billboard-advertising-roi-delhi" },
      { label: "Last Minute Billboard Deals NCR", href: "/last-minute-billboard-deals-ncr" },
    ],
  },
  {
    title: "Advertising Guides & Insights",
    links: [
      { label: "How to Advertise on Billboards in Delhi", href: "/how-to-advertise-on-billboards-in-delhi" },
      { label: "Benefits of Online Billboard Booking", href: "/benefits-of-online-billboard-booking-for-businesses" },
      { label: "How to Choose Online Billboard for Advertising", href: "/how-to-choose-online-billboard-for-advertising" },
      { label: "Common Mistakes in Online Billboard Booking", href: "/common-mistakes-online-billboard-booking" },
      { label: "Digital Outdoor Advertising Companies NCR", href: "/digital-outdoor-advertising-companies-ncr" },
      { label: "Online Billboard Booking Impact on Sales", href: "/online-billboard-booking-impact-on-sales" },
    ],
  },
  {
    title: "Start Your Billboard Journey",
    links: [
      { label: "Book Billboard Online", href: "/book-billboard-online" },
      { label: "Start a Billboard Business", href: "/start-a-billboard-business" },
      { label: "Make Money with Billboard", href: "/money-with-billboard" },
      { label: "Low Investment Ways to Start Your Billboard Business", href: "/low-investment-ways-to-start-your-billboard-business" },
      { label: "Get Paid for Billboards", href: "/get-paid-for-billboards" },
      { label: "Billboard Advertising in Delhi", href: "/billboard-advertising-in-delhi" },
    ],
  },
];

const FAQ = () => {

  const faqs = [
    {
      question: "What is AdBoardBooking.com?",
      answer: (
        <>
          <h3 className="inline font-semibold">AdBoardBooking.com</h3> is an{" "}
          <em>online digital signage booking platform</em> that connects businesses with high-traffic{" "}
          <h3 className="inline font-semibold">digital billboards</h3>, <h3 className="inline font-semibold">LED advertising boards</h3>, and{" "}
          <h3 className="inline font-semibold">digital hoardings</h3> across Delhi NCR. It's the easiest way to{" "}
          <h3 className="inline font-semibold">advertise on billboards</h3> and manage your outdoor ad campaigns online.
        </>
      ),
    },
    {
      question: "Can I choose specific locations for my billboard advertisements?",
      answer: (
        <>
          Yes! Our platform lets you <h3 className="inline font-semibold">book digital billboards in Delhi</h3>,{" "}
          <h3 className="inline font-semibold">rent billboard space in NCR</h3>, and target ads to{" "}
          <h3 className="inline font-semibold">high-traffic billboard locations</h3> in Gurgaon, Noida, and beyond. Use filters to
          pick locations near metro stations, malls, and business districts.
        </>
      ),
    },
    {
      question: "What are the billboard advertising rates on AdBoardBooking.com?",
      answer: (
        <>
          <h3 className="inline font-semibold">Billboard advertising rates in India</h3> vary based on location, screen size, and duration.
          Visit our Pricing page to <h3 className="inline font-semibold">compare billboard prices in Delhi</h3>, or contact us for{" "}
          <h3 className="inline font-semibold">affordable online billboard booking rates</h3> tailored to your budget.
        </>
      ),
    },
    {
      question: "How do I create an advertisement for a digital billboard?",
      answer: (
        <>
          You can upload your creatives using any standard design tool like Photoshop or Canva.
          Ensure your ad meets our specifications. We also offer{" "}
          <h3 className="inline font-semibold">digital menu board solutions</h3> and creative support if you need help designing
          engaging content for your <h3 className="inline font-semibold">LED billboards</h3>.
        </>
      ),
    },
    {
      question: "How long does it take for my ad to go live?",
      answer: (
        <>
          Most ads go live within <h3 className="inline font-semibold">24–48 hours</h3> after booking, depending on{" "}
          <em>adboard availability</em> and content approval. Our{" "}
          <h3 className="inline font-semibold">quick online billboard booking service</h3> ensures fast turnarounds for urgent campaigns.
        </>
      ),
    },
    {
      question: "Do you offer content scheduling and management services?",
      answer: (
        <>
          Yes, we provide complete <h3 className="inline font-semibold">digital signage content management services</h3> to help you
          schedule and update your ads in real time. This is ideal for brands with dynamic or seasonal messaging.
        </>
      ),
    },
    {
      question: "Can I track the performance of my digital ad?",
      answer: (
        <>
          Absolutely. You can view basic metrics such as impressions and playback stats. Want more?
          Our premium plans include advanced tracking to measure{" "}
          <h3 className="inline font-semibold">billboard advertising ROI in Delhi</h3> and evaluate{" "}
          <em>the impact of online billboard booking on sales</em>.
        </>
      ),
    },
    {
      question: "How can I get started with online billboard booking?",
      answer: (
        <>
          It's simple! Just sign up at <h3 className="inline font-semibold">AdBoardBooking.com</h3>, explore listings, and{" "}
          <h3 className="inline font-semibold">book billboard online</h3> in your preferred area. We even offer{" "}
          <h3 className="inline font-semibold">last-minute billboard deals in NCR</h3> and support for{" "}
          <h3 className="inline font-semibold">low-investment billboard campaigns</h3> to help you get started affordably.
        </>
      ),
    },
  ];

  return (
    <div className="nc-PageSingle">
      
      <div className="container mx-auto py-12">
        <Card className="w-full  mx-auto shadow-md rounded-2xl">
          <CardContent className="p-6">
            
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Frequently asked questions</h2>
            <div className="max-w-screen-xl mx-auto">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, i) => (
                  <AccordionItem key={`item-${i}`} value={`item-${i}`}>
                    <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
                    <AccordionContent>{faq.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </CardContent>
        </Card>
        <br />
        <Card className="w-full  mx-auto shadow-md rounded-2xl">
          <CardContent className="p-6">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Explore Billboard Advertising & Digital Signage</h2>
            <Accordion type="multiple" className="w-full">
              {seoLinks.map((category, index) => (
                <AccordionItem key={index} value={`seo-${index}`}>
                  <AccordionTrigger className="text-left text-base font-medium text-gray-700">
                    {category.title}
                  </AccordionTrigger>
                  <AccordionContent className="pl-4">
                    <ul className="space-y-2 list-disc list-inside">
                      {category.links.map((link, i) => (
                        <li key={i}>
                          <a
                            href={"https://blogs.adboardbooking.com"}
                            className="text-sm text-blue-600 hover:underline"
                          >
                            {link.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>
      </div>
     
    </div>
  );
};

export default FAQ;
